import(/* webpackMode: "eager", webpackExports: ["PortalJobs"] */ "/vercel/path0/app/portal/[slug]/portal-jobs.tsx");
